module.exports = __webpack_public_path__ + "static/img/gift-10.405e066.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-10.png
// module id = 354
// module chunks = 140